'use client'

import type { IconName } from '@/components/atomic/icon'

import { isValidElement, type ReactNode } from 'react'

import Accordion, { AccordionType } from '@/components/atomic/accordion'
import { IconBlock } from '@/components/molecules/icon-block'

import {
  ConstraintContainer,
  ConstraintLabelContainer,
  ConstraintLabelInner,
  ConstraintLabelText,
} from './styles'

interface ConstraintProps {
  children: React.ReactNode
  title: string
  displayTitle?: ReactNode
  icon?: IconName
  iconBackgroundColor?: string
  iconColor?: string
  itemClassName?: string
  containerClassName?: string
}

export function Constraint({
  children,
  title,
  displayTitle,
  icon,
  iconBackgroundColor,
  iconColor,
  itemClassName,
  containerClassName,
}: ConstraintProps) {
  return (
    <ConstraintContainer className={containerClassName}>
      <Accordion
        type={AccordionType.Single}
        collapsible
        defaultValue={title}
        items={[
          {
            label: (
              <ConstraintLabelContainer>
                <ConstraintLabelInner>
                  {icon && (
                    <IconBlock
                      icon={icon}
                      backgroundColor={iconBackgroundColor}
                      textColor={iconColor}
                      iconClassName="w-[12px] h-[12px]"
                      className="p-[4px]"
                    />
                  )}
                  {isValidElement(displayTitle) ? (
                    displayTitle
                  ) : (
                    <ConstraintLabelText>
                      {displayTitle || title}
                    </ConstraintLabelText>
                  )}
                </ConstraintLabelInner>
              </ConstraintLabelContainer>
            ),
            content: children,
            value: title,
            className: itemClassName,
          },
        ]}
        className="w-full"
      />
    </ConstraintContainer>
  )
}
